import { render, staticRenderFns } from "./AddLanguages.vue?vue&type=template&id=23f2a60b"
import script from "./AddLanguages.vue?vue&type=script&lang=js"
export * from "./AddLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports